import {useState, useCallback} from '@wordpress/element';
import {loadStripe} from "@stripe/stripe-js";
import {Elements, PaymentElement, useStripe} from '@stripe/react-stripe-js';
import {getSetting} from '@woocommerce/settings'
import {cloneDeep} from 'lodash';
import {
    getSettings,
    //initStripe as loadStripe
} from '../util';
import {Installments} from '../../components/checkout/';

import {useProcessCheckoutError, useProcessCheckoutSuccess, useCreatePaymentMethod} from "../hooks";

const {publishableKey, stripeParams} = getSetting('stripeGeneralData');
const params = cloneDeep(stripeParams);

const stripe = loadStripe(publishableKey, params);


const getData = getSettings('stripe_cc_data');
const i18n = getData('i18n');

const isSetupCard = total => 0 >= total;

export const PaymentElementComponent = (props) => {
    const {billing, cartData, shouldSavePayment} = props;
    const {extensions} = cartData;
    const {cartTotal, currency} = billing;
    let options = {
        mode: 'payment',
        currency: currency?.code?.toLowerCase(),
        ...getData('elementOptions')
    }
    if (shouldSavePayment) {
        options.mode = 'subscription';
    }
    if (isSetupCard(cartTotal.value)) {
        options = {...options, mode: 'setup'}
    }
    if (['payment', 'subscription'].includes(options.mode)) {
        options.amount = cartTotal.value;
    }
    return (
        <>
            <Elements stripe={stripe} options={options}>
                <CardElement {...props} options={options}/>
            </Elements>
        </>
    );
}

const CardElement = ({options, ...props}) => {
    const [formComplete, setFormComplete] = useState(false);
    const installmentsActive = getData('installmentsActive')
    const stripe = useStripe();
    const {
        billing: {billingAddress},
        eventRegistration,
        emitResponse,
        shouldSavePayment,
        activePaymentMethod
    } = props;
    const {
        email,
        phone,
        first_name,
        last_name
    } = billingAddress;
    const {
        onCheckoutSuccess,
        onCheckoutFail
    } = eventRegistration;

    const name = getData('name');
    const onChange = useCallback((event) => {
        setFormComplete(event.complete);
    }, []);

    const {
        createPaymentMethod,
        addPaymentMethodData
    } = useCreatePaymentMethod({
        name,
        emitResponse,
        billingAddress,
        shouldSavePayment,
        eventRegistration,
        activePaymentMethod
    });

    useProcessCheckoutSuccess({
        name,
        emitResponse,
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod,
    });

    useProcessCheckoutError({
        emitResponse,
        subscriber: onCheckoutFail,
        messageContext: emitResponse.noticeContexts.PAYMENTS
    });

    const elementOptions = {
        defaultValues: {
            billingDetails: {
                name: `${first_name} ${last_name}`,
                email,
                phone
            }
        },
        fields: {
            billingDetails: {address: 'never'}
        },
        wallets: {applePay: 'never', googlePay: 'never'},
        ...getData('paymentElementOptions')
    }
    return (
        <>
            <PaymentElement options={elementOptions} onChange={onChange}/>
            <Installments
                active={installmentsActive}
                i18n={i18n}
                paymentMethodType={'card'}
                stripe={stripe}
                cardFormComplete={formComplete}
                createPaymentMethod={createPaymentMethod}
                onChange={(value) => addPaymentMethodData({_stripe_installment_plan: value})}/>
        </>
    )
}

export default PaymentElementComponent;